import React from "react";
import "./OpticksIntegrationStep.css";
import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";

interface Props {
  stepNumber: number;
  stepTitle: string;
  content: React.ReactNode;
  completed?: boolean;
}

const OpticksIntegrationStep = ({
  stepNumber,
  stepTitle,
  content,
  completed,
}: Props) => {
  return (
    <div className="opticks-integration-step">
      <div className="opticks-integration-step-header">
        <OpticksNumberCircle number={stepNumber} completed={completed} />
        <h6>{stepTitle}</h6>
      </div>
      <div className="opticks-integration-step-content">{content}</div>
    </div>
  );
};

export default OpticksIntegrationStep;
